import type { JsonTranslation, JsonTranslations } from '~/clients'
import _ from 'lodash'

export const getTranslationValue = (
  item?: JsonTranslation | object | null,
  fallback: unknown = '',
  locale?: string,
) => {
  let activeLocale = locale
  if (!activeLocale) {
    try {
      const nuxtApp = useNuxtApp()
      activeLocale = nuxtApp?.$i18n?.locale?.value ?? 'en'
    } catch {
      activeLocale = 'en'
    }
  }
  const code = ref(activeLocale)

  if (!item) return fallback

  const codeEmpty = _.isEmpty(item[code.value])
  const enEmpty = _.isEmpty(item['en'])

  if (codeEmpty && enEmpty) return fallback
  if (codeEmpty && !enEmpty) return item['en']

  return item[code.value]
}

export const getTranslationValues = (item?: JsonTranslations, fallback: string = '') => {
  let activeLocale = 'en'
  try {
    const nuxtApp = useNuxtApp()
    activeLocale = nuxtApp?.$i18n?.locale?.value ?? 'en'
  } catch {
    activeLocale = 'en'
  }

  return item?.[activeLocale]?.join(', ') ?? item?.['en']?.join(', ') ?? fallback
}

export const getTranslationPath = (
  items: JsonTranslation[] = [],
  code: string,
  fallback: string = 'en',
): string => {
  const item = items.find((item) => item.language === code)

  if (!item) {
    const fallbackItem = items.find((item) => item.language === fallback)
    return fallbackItem ? fallbackItem.path : ''
  }
  return item.path
}

export const createEmptyTranslation = (): JsonTranslation => {
  return {
    en: '',
    nl: '',
    de: '',
  }
}

export const simpleHtmlFormat = (content: string, discardOnlyBreaks = true): string => {
  // Return empty if content is falsy
  if (!content) return ''

  // Trim whitespace
  // Removes leading and trailing: null, horizontal tab, line feed, vertical tab, form feed, carriage return, space
  // eslint-disable-next-line no-control-regex
  const trimmed = content.replace(/^[\x00\t\n\v\f\r ]+|[\x00\t\n\v\f\r ]+$/g, '')

  // If discardOnlyBreaks is enabled, remove strings that are only line breaks/whitespace
  if (discardOnlyBreaks && /^\s*$/.test(trimmed.replace(/\n/g, ''))) {
    return ''
  }

  const escaped = trimmed
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;')

  // Replace both escaped and real line breaks with <br/>
  return escaped.replace(/\n/g, '<br/>')
}
